module.exports = __webpack_public_path__ + "static/assets/6501f7ed297cb10ddd19fbb59e6dc9b9.png";